<template>
  <v-row>
    <v-col class="pl-0 ml-n2">
      <v-autocomplete
        v-model="selectedItems"
        item-text="name"
        item-value="id"
        :items="items"
        label="Groupe"
        :menu-props="{ maxHeight: '400', zIndex: 13 }"
        multiple
        outlined
        dense
      ></v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "BusinessFilter",
  data() {
    return {};
  },
  async created() {
    await this.$store.dispatch("audience/getAcpmBusinessList");
  },
  computed: {
    items() {
      return this.$store.getters["audience/getAcpmBusinessList"];
    },
    selectedItems: {
      get() {
        return this.$store.getters["audience/getAcpmBusinesses"];
      },
      set(ids) {
        this.$store.dispatch("audience/updateAcpmBusinesses", ids);
      },
    },
  },
};
</script>

<style scoped></style>
